module.exports = __webpack_public_path__ + "static/media/linkedin.d2f62f73.jpg";